module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "homePageMain"
  }, [_c('h1', {
    staticClass: "homePageMain__header"
  }, [_c('span', {
    staticClass: "homePageMain__spanWrap"
  }, [_c('span', {
    staticClass: "homePageMain__span"
  }, [_vm._v("resursable")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8b48942","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homePageMain.vue
// module id = 79
// module chunks = 0